import {
  AuthTokenSource,
  GlobalTokenDebuggingEvent,
  ISourceTokenDebugger,
  ITokenDebugger,
  TokenDebuggingEvent,
} from './authTokenTypes';

export class SourceTokenDebugger implements ISourceTokenDebugger {
  constructor(private readonly source: AuthTokenSource) {}

  addEvent(event: TokenDebuggingEvent): void {
    console.info(JSON.stringify({ event, source: this.source }));
  }
}

export class TokenDebugger implements ITokenDebugger {
  debuggers: Record<string, ISourceTokenDebugger> = {};

  addEvent(source: AuthTokenSource, event: TokenDebuggingEvent): void {
    this.forSource(source).addEvent(event);
  }

  addGlobalEvent(event: GlobalTokenDebuggingEvent): void {
    console.info(JSON.stringify({ event }));
  }

  forSource(source: AuthTokenSource): ISourceTokenDebugger {
    if (!this.debuggers[source]) {
      this.debuggers[source] = new SourceTokenDebugger(source);
    }
    return this.debuggers[source];
  }
}
